module.exports = __webpack_public_path__ + "static/img/map-img-02@w.8be88de.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/haevichi/map-img-02@w.png
// module id = CcRk
// module chunks = 0